<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<!-- eslint-disable vuejs-accessibility/anchor-has-content -->

<template>
  <nav
    class="navbar navbar-expand-lg navbar-light bg-light"
    style="box-shadow: 0px 14px 24px #e4e4e4"
  >
    <div class="container-fluid">
      <div class="navbar-brand ms-1">
        <router-link to="/index">
          <img :src="logo" alt="" style="max-width: 100%; max-height: 51px" />
        </router-link>
        <span class="version">v2.6.2.1</span>
      </div>
      <ul class="nav align-items-center flex-nowrap mb-0 justify-content-end header-actions">
        <li class="topbar-item ms-2 text-muted rwd-md-hide">
          {{ this.$store.state.user.emp_code }} (
          <span> {{ this.$store.state.user.name }} </span>
          )
        </li>

        <!-- 其他功能對話框 -->
        <othersDialog
          :othersDialogVisible="othersDialogVisible"
          @visibleEmit="othersVisibleStatus"
          @emitEditSwitch="emitEditSwitch"
          @emitLogout="logoutMethod"
          :noisePoint="noisePoint"
          :dataType="dataType"
          :noisePointPermission="noisePointPermission"
          :dataTypePermission="dataTypePermission"
        ></othersDialog>

        <!-- 在線列表對話框 -->
        <ccuDialog :dialogVisible="ccuVisible" @visibleEmit="ccuVisibleStatus"></ccuDialog>

        <!-- 個人資料對話框 -->
        <el-dialog
          v-model="dialogVisible"
          :title="i18n.$t('Label')['userinfo']"
          :z-index="1000"
          :width="dialogWidth"
          :close-on-click-modal="false"
        >
          <loading :isLoading="dataGeting"></loading>
          <el-form :model="editData[0]" :rules="formRules" ref="form">
            <el-tabs type="border-card" v-model="activeTab">
              <!-- 資料修改 -->
              <el-tab-pane :label="i18n.$t('Label')['infoedit']">
                <div v-if="activeTab === '0'" class="form-wrap">
                  <ul class="createuser-group">
                    <el-row>
                      <el-col :span="11">
                        <div class="li-object">
                          <li class="public-li">
                            <p>{{ i18n.$t('Label')['account'] }}</p>
                          </li>
                          <el-form-item prop="account">
                            <el-input
                              type="text"
                              id="account"
                              required="required"
                              class="account"
                              v-model="editData[0].account"
                              disabled
                              maxlength="25"
                              show-word-limit
                            />
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="11"> </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="11">
                        <div class="li-object">
                          <li class="public-li">
                            <p>{{ i18n.$t('Label')['aname'] }}<span class="required">*</span></p>
                          </li>
                          <el-form-item prop="name">
                            <el-input
                              type="text"
                              id="name"
                              required="required"
                              class="name"
                              v-model="editData[0].name"
                              maxlength="25"
                              show-word-limit
                          /></el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="11">
                        <div class="li-object">
                          <li class="public-li">
                            <p>{{ i18n.$t('Label')['empid'] }}</p>
                          </li>
                          <el-form-item prop="emp_code">
                            <el-input
                              type="text"
                              id="id"
                              required="required"
                              class="id"
                              v-model="editData[0].emp_code"
                              disabled
                              maxlength="25"
                              show-word-limit
                          /></el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="11">
                        <div class="li-object">
                          <li class="public-li">
                            <p>{{ i18n.$t('Label')['mobile'] }}</p>
                          </li>
                          <el-form-item prop="mobile">
                            <el-input
                              type="text"
                              id="mobile"
                              class="mobile"
                              v-model="editData[0].mobile"
                              maxlength="20"
                              show-word-limit
                          /></el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="11">
                        <div class="li-object">
                          <li class="public-li">
                            <p>{{ i18n.$t('Label')['email'] }}</p>
                          </li>
                          <el-form-item prop="email">
                            <el-input
                              type="text"
                              id="email"
                              class="email"
                              v-model="editData[0].email"
                              maxlength="100"
                              show-word-limit
                          /></el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="11">
                        <div class="li-object">
                          <li class="public-li">
                            <p>{{ i18n.$t('Label')['login_type'] }}</p>
                          </li>
                          <el-form-item prop="login_type">
                            <el-input
                              type="text"
                              id="login_type"
                              class="login_type"
                              v-model="editData[0].login_type"
                              disabled
                              maxlength="50"
                              show-word-limit
                          /></el-form-item>
                        </div>
                      </el-col>
                      <el-col :span="11" v-show="frontend_mode !== 'lxs'">
                        <div class="li-object">
                          <li class="public-li">
                            <p>{{ i18n.$t('Label')['wechat_account'] }}</p>
                          </li>
                          <el-form-item prop="wechat">
                            <el-input
                              type="text"
                              id="wechat"
                              class="wechat"
                              v-model="editData[0].wechat"
                              maxlength="20"
                              show-word-limit
                          /></el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <div class="btn-wrap">
                      <span class="dialog-footer">
                        <el-button class="btn-cancel" @click="dialogClose">{{
                          i18n.$t('Button').cancel
                        }}</el-button>
                        <el-button
                          type="primary"
                          class="btn-confirm"
                          style="height: initial"
                          :disabled="!license || updateInfo"
                          @click="updateUserInfoApi"
                          >{{ i18n.$t('Button').confirm }}
                        </el-button>
                      </span>
                    </div>
                  </ul>
                </div>
              </el-tab-pane>

              <!-- 密碼修改 -->
              <el-tab-pane :label="i18n.$t('Label')['pwedit']">
                <div v-if="activeTab === '1'" class="form-wrap">
                  <ul class="createuser-group">
                    <el-row>
                      <el-col :span="11">
                        <div class="li-object">
                          <li class="public-li">
                            <p>{{ i18n.$t('Label')['account'] }}</p>
                          </li>
                          <el-input
                            type="text"
                            id="account"
                            required="required"
                            class="account"
                            v-model="editData[0].account"
                            maxlength="50"
                            show-word-limit
                            disabled
                          />
                        </div>
                      </el-col>
                      <el-col :span="11">
                        <div class="li-object">
                          <li class="public-li">
                            <p>{{ i18n.$t('Label')['password'] }}<span class="required">*</span></p>
                          </li>
                          <el-form-item prop="password">
                            <el-input
                              type="password"
                              id="password"
                              required="required"
                              class="password"
                              v-model="editData[0].password"
                              autocomplete="off"
                              show-password
                              maxlength=" 25"
                          /></el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <div class="btn-wrap">
                      <span class="dialog-footer">
                        <el-button class="btn-cancel" @click="dialogClose">{{
                          i18n.$t('Button').cancel
                        }}</el-button>
                        <el-button
                          type="primary"
                          class="btn-confirm"
                          style="height: initial"
                          @click="pwUpdateApi"
                          :disabled="!license || updatePw"
                          >{{ i18n.$t('Button').confirm }}
                        </el-button>
                      </span>
                    </div>
                  </ul>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </el-dialog>

        <li class="topbar-item ms-2 dropdownDiv" id="selectFactory">
          <loading :isLoading="this.$store.getters.getBUlist.length === 0"></loading>

          <el-select
            v-if="this.$store.getters.getBUlist.length === 0"
            class="rwd-sm-hide"
            placeholder="廠區"
            size="large"
            @change="changNowBU"
          />
          <el-select
            v-else
            v-model="nowShowing"
            class="rwd-sm-hide"
            placeholder="廠區"
            size="large"
            @change="changNowBU"
          >
            <el-option
              v-for="(item, index) in this.$store.getters.getBUlist"
              :key="index"
              :label="item.re_name"
              :value="JSON.stringify(item)"
            />
          </el-select>
        </li>

        <li class="topbar-item ms-2 languageDropdownDiv" id="selectLanguage">
          <el-select v-model="getLang" size="large" @change="setLang" class="rwd-sm-hide">
            <el-option value="zhtw" :label="i18n.$t('Lang_op_tw')"></el-option>
            <el-option value="cn" :label="i18n.$t('Lang_op_cn')"></el-option>
            <el-option value="en" :label="i18n.$t('Lang_op_en')"></el-option>
            <!-- <el-option value="de" :label="i18n.$t('Lang_op_de')"></el-option>
            <el-option value="th" :label="i18n.$t('Lang_op_th')"></el-option>
            <el-option value="fr" :label="i18n.$t('Lang_op_fr')"></el-option> -->
          </el-select>
        </li>

        <!-- 藍色選單 -->
        <li class="topbar-item ms-2" id="menu">
          <el-dropdown trigger="click" style="margin-left: 10px">
            <span class="el-dropdown-link">
              <el-button type="primary" style="height: 40px">
                {{ i18n.$t('Chart').option }}
                <el-icon class="el-icon--right">
                  <arrow-down />
                </el-icon>
              </el-button>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item class="rwd-sm-show" @click="buDialogVisible = true">
                  {{ i18n.$t('bu') }}
                </el-dropdown-item>
                <el-dropdown-item class="rwd-sm-show" @click="langDialogVisible = true">
                  {{ i18n.$t('language') }}
                </el-dropdown-item>
                <el-dropdown-item @click="openConcurrentUser">
                  {{ i18n.$t('OnlineStatus').online_list }}
                </el-dropdown-item>
                <el-dropdown-item @click="openSetting">
                  {{ i18n.$t('Label').userinfo }}
                </el-dropdown-item>

                <!-- 其他功能 -->
                <el-dropdown-item
                  v-if="(noisePointPermission || dataTypePermission) && nowBUkey !== '.'"
                  :disabled="!AUD"
                  @click="othersVisibleStatus(true)"
                >
                  {{ i18n.$t('Label').display }}
                </el-dropdown-item>

                <el-dropdown-item @click="logoutMethod">
                  {{ i18n.$t('logout_text') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </li>

        <el-dialog
          v-model="buDialogVisible"
          :title="i18n.$t('bu')"
          width="248px"
          :before-close="buDialogClose"
          :close-on-click-modal="false"
          align-center
        >
          <el-select v-model="nowShowing" placeholder="廠區" size="large" @change="changNowBU">
            <el-option
              v-for="(item, index) in this.$store.getters.getBUlist"
              :key="index"
              :label="item.re_name"
              :value="JSON.stringify(item)"
            />
          </el-select>
        </el-dialog>

        <el-dialog
          v-model="langDialogVisible"
          :title="i18n.$t('bu')"
          width="248px"
          :before-close="langDialogClose"
          :close-on-click-modal="false"
          align-center
        >
          <el-select v-model="getLang" size="large" @change="setLang">
            <el-option value="zhtw" :label="i18n.$t('Lang_op_tw')"></el-option>
            <el-option value="cn" :label="i18n.$t('Lang_op_cn')"></el-option>
            <el-option value="en" :label="i18n.$t('Lang_op_en')"></el-option>
            <el-option value="de" :label="i18n.$t('Lang_op_de')"></el-option>
            <el-option value="th" :label="i18n.$t('Lang_op_th')"></el-option>
            <el-option value="fr" :label="i18n.$t('Lang_op_fr')"></el-option>
          </el-select>
        </el-dialog>
      </ul>
    </div>
  </nav>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable no-else-return */
/* eslint-disable consistent-return */
import { useI18n } from '@/js/i18n';
import { store } from '@/store';
import {
  SystemAuthRemoveTokenDel,
  SwitchBUCheckDB,
  SystemPermissionGetMenuItemGet,
  SystemUserGetList,
  SystemUserUpdate,
  SystemUserPwUpdate,
  SystemLicenseStatusGet,
} from '@/js/api/system';
import { BuUserGetOther } from '@/js/api/bu_C';
import { TabsLogout } from '@/js/api/userauth';
import { ElMessage } from 'element-plus';
import ccuDialog from '@/components/concurrentUsers/ccuList.vue';
import loading from '@/components/loading.vue';
import othersDialog from '@/components/headerBarFunc/othersDialog.vue';
// import router from '@/router';
import { showMsg } from '@/js/basic';
import { getCurrentInstance, ref, onMounted } from 'vue';
import defaultLogo from '../assets/img/logo.png';
import router from '@/router/index';

export default {
  components: {
    ccuDialog,
    loading,
    othersDialog,
  },
  // name: 'idx',
  setup() {
    const i18n = useI18n();
    const instance = getCurrentInstance();
    // const apiLang = sessionStorage.getItem('setLang');
    const setLang = (value) => {
      store.commit('setLang', value);
      sessionStorage.setItem('userLang', value);
      i18n.locale.value = value;
      instance.proxy.$data.langDialogVisible = false;
    };
    const nowBUkey = ref('.');

    /** 切換廠區 */
    const changNowBU = (value) => {
      // console.log(`changNowBU :: ${value}`);
      // 切換顯示 >> 先判斷是否是廠區
      // 是廠區 >> 經過 API 連接確認 >> 存 sessionStorage + store
      // 非廠區 >> 切頁面 + 存 sessionStorage + store
      let selectedData = JSON.parse(value);

      nowBUkey.value = selectedData.sys_bu;
      // console.log('nowBUkey1', nowBUkey.value);

      // 存欲換介面
      store.commit('setLoadingName', selectedData);

      // 開啟整個介面的 Loading
      store.commit('setPageLoading', true);

      sessionStorage.removeItem('searchCatch');
      if (selectedData.sys_bu !== '.') {
        //
        // 是廠區
        //

        // 開啟整個介面的 Loading
        store.commit('setPageLoading', true);

        SwitchBUCheckDB({ sys_bu: selectedData.sys_bu })
          .then((res) => {
            console.log('SwitchBUCheckDB res.data', res.data);
            if (res.data.success) {
              // store.commit('setNowBU', selectedData); // 目前介面資料存取
              // sessionStorage.setItem('nowShowing', value); // 存取切換介面
              // this.$router.push('/index'); => watch 監聽 key 是否改變去切換
              // =============================
              SystemPermissionGetMenuItemGet({ bu_key: selectedData.sys_bu })
                .then((resM) => {
                  console.log('SystemPermissionGetMenuItemGet resM', resM);
                  if (resM.data.success) {
                    sessionStorage.setItem('MainMenu', JSON.stringify(resM.data.result));
                    store.commit('setNowBU', selectedData); // 目前介面資料存取c
                    sessionStorage.setItem('nowShowing', value); // 存取切換介面
                  }
                })
                .catch((error) => {
                  ElMessage({
                    showClose: true,
                    message: `取得BU選單失敗：${error}`,
                    type: 'error',
                    duration: 3000,
                  });
                });
              // =============================
            } else {
              ElMessage({
                showClose: true,
                message: `${selectedData.re_name} 資料庫連線失敗：${JSON.stringify(res.data)}`,
                type: 'error',
                duration: 3000,
              });
            }

            // 關掉整個介面的 Loading
            store.commit('setPageLoading', false);
          })
          .catch((error) => {
            // console.log(error);

            // 關掉整個介面的 Loading
            store.commit('setPageLoading', false);
            ElMessage({
              showClose: true,
              message: `資料庫連線失敗：${error}`,
              type: 'error',
              duration: 3000,
            });
          });
        // ===========================
      } else {
        //
        // 非廠區
        //

        console.log('非廠區');

        // 目前介面資料存取
        store.commit('setNowBU', selectedData);

        // 存取切換介面
        sessionStorage.setItem('nowShowing', value);

        // 關掉整個介面的 Loading
        store.commit('setPageLoading', false);
      }
    };

    const changeDataType = (value) => {
      console.log(value);
    };
    onMounted(() => {
      const stored = sessionStorage.getItem('nowShowing');
      if (stored) {
        nowBUkey.value = JSON.parse(stored).sys_bu || '.';
        // console.log('初始 nowBUkey:', nowBUkey.value);
      }
    });
    return {
      nowBUkey,
      i18n,
      setLang,
      changNowBU,
      changeDataType,
    };
  },
  computed: {
    getLang() {
      let lang = 'zhtw';
      if (this.$store.state.lang) {
        lang = this.$store.state.lang;
      }
      return lang;
    },
    updateInfo() {
      let dis = true;
      Object.values(this.editData[0]).forEach((val, index) => {
        // console.log(val);
        if (val !== Object.values(this.apiResult[0])[index]) {
          // console.log(Object.values(this.editData[0])[index]);
          dis = false;
        }
      });
      return dis;
    },
    updatePw() {
      let dis = true;
      // console.log(this.editData[0].password);
      if (this.editData[0].password !== '' && this.editData[0].password !== undefined) {
        dis = false;
      }
      return dis;
    },
  },
  data() {
    return {
      logo: '',
      license: false,

      /** 前端模式 */
      frontend_mode: '',

      AUD: false,
      custom: '',

      /** 是否顯示在線列表對話框 */
      ccuVisible: false,

      DisplaySystemSetting: false,
      stopTrainSend: false,
      // nowBUSelected: '.',

      /** 啟用編輯功能 */
      dataType: false,
      dataTypePermission: false,

      /** 啟用隱藏功能 */
      noisePoint: false,
      noisePointPermission: false,

      /** 是否顯示其他功能對話框 */
      othersDialogVisible: false,

      dialogWidth: '480px',
      buDialogVisible: false,
      langDialogVisible: false,
      buList: [],
      // i18nOption:['zhtw','en'],
      nowShowing: sessionStorage.getItem('nowShowing') ? sessionStorage.getItem('nowShowing') : '', // { re_name: '', sys_bu: '' }

      /** 是否顯示個人資料對話框 */
      dialogVisible: false,

      dataGeting: false,
      activeTab: '0',
      apiResult: [
        {
          account: '',
          password: '',
          name: '',
          emp_code: '',
          email: '',
          mobile: '',
          wechat: '',
        },
      ],
      editData: [
        {
          account: '',
          password: '',
          name: '',
          emp_code: '',
          email: '',
          mobile: '',
          wechat: '',
        },
      ],
      formRules: {
        name: [
          {
            required: true,
            message: () => {
              const formatMessage = this.i18n.$t('Msg').format;
              return formatMessage;
            },
            trigger: ['blur', 'change'],
            pattern: /^[\w\u4e00-\u9fa5\-_() \t]*[\w\u4e00-\u9fa5\-_()]{0,25}$/,
          },
        ],
        password: [
          {
            required: true,
            message: () => {
              const formatMessage = this.i18n.$t('Msg').format;
              return formatMessage;
            },
            trigger: ['blur', 'change'],
            pattern: /^[a-zA-Z0-9!#$%&()*+,-./:;<=>?@[\]^_`{|}~\s]{1,25}$/,
          },
        ],
        mobile: [
          {
            message: () => {
              const formatMessage = this.i18n.$t('Msg').format;
              return formatMessage;
            },
            trigger: ['blur', 'change'],
            pattern: /^\d{1,20}$/,
          },
        ],
        email: [
          {
            type: 'email',
            message: () => {
              const formatMessage = this.i18n.$t('Msg').format;
              return formatMessage;
            },
            trigger: ['blur', 'change'],
          },
        ],
      },
    };
  },
  mounted() {
    this.logo = sessionStorage.getItem('logo') ? sessionStorage.getItem('logo') : defaultLogo;
    this.frontend_mode = sessionStorage.getItem('frontend_mode');
    this.apiGetLicenseStatus();
    this.AUD = this.$store.dispatch('LicenseJudge', { str: 'AUD' });
    this.custom = process.env.VUE_APP_Customer;
    // 防止 refresh 時 state 中的 BU資料清掉
    this.$store.dispatch('getBUSysList', { msg: this.i18n.$t('Msg').get_bulist_error });
    this.$store.dispatch('getBuDatafromSessionStorage');
    this.$store.dispatch('setUserInfo');
  },

  methods: {
    /** api取得系統授權狀態 */
    apiGetLicenseStatus() {
      SystemLicenseStatusGet()
        .then((res) => {
          this.licenseStatus = res.data.result.flag;
          this.frontend_mode = res.data.result.frontend_mode;

          sessionStorage.setItem('frontend_mode', res.data.result.frontend_mode);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    setDialogWidth() {
      const windowSize = document.body.clientWidth;
      // console.log(windowSize);
      const defaultWidth = 480; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dialogWidth = '100%';
      } else {
        this.dialogWidth = '480px';
      }
      // console.log(this.dialogWidth);
    },

    /** 開啟在線列表對話框 */
    openConcurrentUser() {
      this.ccuVisible = true;
    },

    /** 接收在線列表對話框值 */
    ccuVisibleStatus(val) {
      this.ccuVisible = val;
    },

    SystemSetting() {
      const GloableMenu = JSON.parse(sessionStorage.getItem('MainMenu') || '[]');
      const result = GloableMenu.filter((item) => {
        return item.system === true;
      });
      this.DisplaySystemSetting = result && result.length > 0;
    },

    /** 登出 */
    logoutMethod() {
      this.$confirm(`${this.i18n.$t('Msg').logout_msg}`, `${this.i18n.$t('logout_text')}`, {
        confirmButtonText: `${this.i18n.$t('Button').confirm}`,
        cancelButtonText: `${this.i18n.$t('Button').cancel}`,
        type: 'warning',
      })
        .then(() => {
          // 之前會傳 { userid, token } 過去，2022-11-09 改為不用傳
          SystemAuthRemoveTokenDel().then((res) => {
            // console.log(res);
            if (res.data.success) {
              localStorage.clear();

              // 從sessionStorage移除之前存的所有資料
              sessionStorage.clear();

              // 使用者資料更新
              this.$store.commit('setUser', { name: '', account: '', id: '' });

              const routerResult = TabsLogout();
              router.push(routerResult);
              this.$message.success(this.i18n.$t('Msg').logout_success);
            }
          });
        })
        .catch((action) => {
          this.$message({
            type: 'info',
            message:
              action === 'cancel'
                ? `${this.i18n.$t('Msg').logout_cancel}`
                : `${this.i18n.$t('Msg').logout_cancel}`,
            // 前面是點選 稍後手動讀取 按鈕顯示的訊息；後面是點選 訊息右上角叉叉顯示的訊息
          });
        });
    },

    switchBUMenu(selectedData, value) {
      SystemPermissionGetMenuItemGet({ bu_key: selectedData.sys_bu })
        .then((res) => {
          if (res.data.success) {
            sessionStorage.setItem('MainMenu', JSON.stringify(res.data.result));

            // 目前介面資料存取
            store.commit('setNowBU', selectedData);

            // 存取切換介面
            sessionStorage.setItem('nowShowing', value);

            // console.log(this.$store.state.nowBUKey);
          }
        })
        .catch((error) => {
          ElMessage({
            showClose: true,
            message: `取得BU選單失敗：${error}`,
            type: 'error',
            duration: 3000,
          });
        });
    },

    apiGetData() {
      this.dataGeting = true;
      SystemUserGetList({ uuid: this.$store.state.user.id })
        .then((res) => {
          if (res.data.success) {
            if (res.data.result.length < 1) {
              this.apiResult = [];
            } else {
              this.apiResult = res.data.result[0].raw_data;
              // console.log(res.data.result[0].raw_data);
              if (res.data.result[0].raw_data[0].email === null) {
                this.apiResult[0].email = '';
              }
              if (res.data.result[0].raw_data[0].mobile === null) {
                this.apiResult[0].mobile = '';
              }
              if (res.data.result[0].raw_data[0].wechat === null) {
                this.apiResult[0].wechat = '';
              }
              this.editData = JSON.parse(JSON.stringify(this.apiResult));
              // console.log(this.apiResult);
              // console.log(this.editData);
            }
          } else {
            this.$store.dispatch('handleMsgError', { errorMsg: res.data.msg });
          }
          // this.searchOption = [...new Set(tempArr)];
          this.dataGeting = false;
        })
        .catch((error) => {
          console.log(error);
          this.dataGeting = false;
        });
    },

    /** 開啟個人資料對話框 */
    async openSetting() {
      try {
        this.license = await this.$store.dispatch('LicenseJudge', {
          str: 'SUP',
          msg: this.i18n.$t('Msg').module_lock,
        });
      } catch (error) {
        console.error(error);
      }
      this.apiGetData();
      this.setDialogWidth();
      this.dialogVisible = true;
    },

    dialogClose() {
      this.dialogVisible = false;
    },

    buDialogClose() {
      this.buDialogVisible = false;
    },

    langDialogClose() {
      this.langDialogVisible = false;
    },

    /** 更新使用者資料 */
    updateUserInfoApi() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // console.log('success');
          const data = this.editData[0];
          data.enable = '1';
          data.name = data.name.trim(); // 去前後空格

          SystemUserUpdate(data)
            .then((res) => {
              if (res.data.success) {
                this.$message.success(this.i18n.$t('Msg').success);
                this.dialogVisible = false;

                // 判斷修改的資訊是否為當前使用者
                if (this.$store.state.user.id === data.uuid) {
                  this.$store.commit('setUser', {
                    name: data.name,
                    emp_code: data.emp_code,
                    id: data.uuid,
                  }); // 使用者資料更新
                  sessionStorage.setItem('user_name', data.name);
                  sessionStorage.setItem('email', data.email);
                }
              } else {
                this.$store.dispatch('handleMsgError', { errorMsg: res.data.msg });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          showMsg(`${this.i18n.$t('Msg').format}`, 'error', 3000);
        }
      });
    },

    /** 密碼更新 */
    pwUpdateApi() {
      const data = {};
      data.uuid = this.editData[0].uuid;
      data.password = this.editData[0].password;
      SystemUserPwUpdate(data)
        .then((res) => {
          if (res.data.success) {
            this.$message.success(this.i18n.$t('Msg').success);
            this.dialogVisible = false;
          } else {
            this.$store.dispatch('handleMsgError', { errorMsg: res.data.msg });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /** 從api取得廠區角色允許的權限清單設值 */
    apiGetRoleOtherPermission() {
      BuUserGetOther({
        bu_key: JSON.parse(sessionStorage.getItem('nowShowing')).sys_bu,
        user_id: sessionStorage.getItem('user_id'),
        info_flag: 1,
      })
        .then((result) => {
          if (result.data.success) {
            store.commit('setBuRolePermission', result.data.result[0]);
            this.dataTypePermission =
              this.$store.state.buRolePermission.switch_audit !== undefined
                ? this.$store.state.buRolePermission.switch_audit
                : false;
            this.noisePointPermission =
              this.$store.state.buRolePermission.switch_hide !== undefined
                ? this.$store.state.buRolePermission.switch_hide
                : false;
            this.dataType = this.$store.state.buRolePermission.view_audit
              ? this.$store.state.buRolePermission.view_audit
              : false;
            this.noisePoint = this.$store.state.buRolePermission.view_hide
              ? this.$store.state.buRolePermission.view_hide
              : false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /** 開啟或關閉其他功能對話框 */
    othersVisibleStatus(val) {
      this.othersDialogVisible = val;
    },

    /**
     * 接收其他功能之 啟用隱藏功能、啟用編輯功能
     * @param editSwitch
     */
    emitEditSwitch(editSwitch) {
      this.noisePoint = editSwitch.editNoisePoint;
      this.dataType = editSwitch.editDataType;
      this.othersVisibleStatus(false);
    },
  },

  updated() {
    // console.log('updated');
  },

  created() {
    // 經由監聽 this.$store.getters.getNowUIKey 去確認要切換哪個介面
    this.$store.watch(
      () => {
        return this.$store.getters.getNowUIKey;
      },
      (newValue, oldValue) => {
        // 有任何一個是空值就不跳轉
        if (oldValue !== '' && newValue !== '') {
          if (oldValue !== newValue) {
            if (newValue === '.') {
              this.dataTypePermission = false;
              this.noisePointPermission = false;
              this.$router.push('/system/As_2');
            } else {
              this.$router.push('/index');
            }
          }
        }
      },
    );
  },

  watch: {
    dataType: {
      handler(val) {
        store.commit('setUserPermissionSwitch', {
          dataTypePermission: val,
          noisePointPermission: this.noisePoint,
        });
      },
      immediate: true, // 立即执行一次
    },
    noisePoint: {
      handler(val) {
        store.commit('setUserPermissionSwitch', {
          dataTypePermission: this.dataType,
          noisePointPermission: val,
        });
      },
      immediate: true, // 立即执行一次
    },
    '$store.state.nowBUKey': {
      handler(val, old) {
        if (val !== old) {
          this.apiGetRoleOtherPermission();
        }
      },
      deep: true,
      immediate: true, // 立即执行一次
    },
  },
};
</script>

<style scoped>
.navbar-brand {
  display: flex;
  min-width: 0;
  flex-shrink: 1;
  margin-left: -26px;
}

.navbar-brand > a {
  min-width: 0;
  max-width: 500px;
}

.navbar > .container-fluid {
  flex-wrap: nowrap;
}

.header-actions {
  flex: 1 0 auto;
}

.navbar {
  position: fixed;
  width: 100%;
  min-height: var(--app-header-height, 77px);
  z-index: var(--app-z-header, 1000);
}

.version {
  position: absolute;
  top: 63px;
  left: 20px;
  font-size: 10px;
  color: #888988;
  font-weight: 600;
}

.form-select {
  height: 40px;
}

:deep(.el-button--info.is-plain) {
  height: 40px;
}

.user-option {
  position: fixed;
  top: 63px;
  right: 543px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.createuser-group > li {
  margin: 5px;
}

.li-object > li {
  left: 100px;
  font-size: 1rem;
}

.li-object > label,
.li-object > .optionSelect {
  display: flex;
}

.li-object > label > span {
  line-height: 35px;
}

.required {
  color: red;

  margin-right: 4px;
}

.btn-wrap {
  margin: 0 auto;
  margin-top: 20px;
  text-align: right;
}

.el-row {
  justify-content: space-between;
}

@media (max-width: 819px) {
  .rwd-sm-hide {
    display: none;
  }

  .dropdownDiv,
  .languageDropdownDiv {
    display: none;
  }
}

@media (min-width: 820px) {
  :deep(.el-dropdown-menu__item.rwd-sm-show) {
    display: none;
  }
}

@media (max-width: 999px) {
  .rwd-md-hide {
    display: none;
  }
}

.dropdownDiv {
  width: 140px;
  flex-shrink: 0;
}

.languageDropdownDiv {
  width: 110px;
  flex-shrink: 0;
}
</style>

<style>
.videoExplain {
  max-width: 850px !important;
}

.imgExplain {
  max-width: 850px !important;
  /* transform: translateY(-100px); */
}

.profileImgExplain {
  max-width: 470px !important;
  /* transform: translateY(-100px); */
}
</style>
